const BASE_URL =
  process.env.NODE_ENV === "development"
    ? ""
    : "https://api.mercadoterra.com.br";

export const API_URLS = {
  baseUrl: process.env.NODE_ENV === "development" ? "/" : BASE_URL,
  users: `${BASE_URL}/users`,
  deleteusers: `${BASE_URL}/users/byadmin`,
  login: `${BASE_URL}/admin/auth/login`,
  role: `${BASE_URL}/admins/profile`,
  cadastro: `${BASE_URL}/users`,
  gerenciar: `${BASE_URL}/admins`,
  categorias: `${BASE_URL}/categories`,
  subcategorias: `${BASE_URL}/subcategories`,
  ads: `${BASE_URL}/ads/byadmin`,
  gerenciarAds: `${BASE_URL}/ads/reasonStatus`,
  planos: `${BASE_URL}/plans`,
  pagamentos: `${BASE_URL}/payments/all`,
  legal: `${BASE_URL}/legal`,
  admincities: `${BASE_URL}/admin-cities`,
  notifications: `${BASE_URL}/notifications`,
  sorteios: `${BASE_URL}/draws`,
  competition: `${BASE_URL}/admin/scale-competitions`,
};
